// extracted by mini-css-extract-plugin
module.exports = {"preview_card":"PreviewButton_preview_card__jwgyT","edit_card":"PreviewButton_edit_card__2a3Rl"};